import { defineStore } from 'pinia'
import { axiosClient } from '@/utils/axios-client'
import type { Address } from '@/types/nest/customer'
import type { UUID } from 'crypto'
import { ref, type Ref } from 'vue'

export const useAddressStore = defineStore('addressStore', () => {
  const address: Ref<Address | null> = ref(null)
  const addresses: Ref<Address[] | null> = ref(null)

  async function fetchCustomerAddress(id: UUID) {
    const response = await axiosClient.request<Address>({
      url: `addresses/${id}`,
      method: 'GET',
    })

    address.value = response.data
    return response.data
  }

  async function updateCustomerAddress(data: Partial<Address>) {
    await axiosClient.request<Address>({
      url: `/addresses/${data.id}`,
      method: 'PUT',
      data: data,
    })
  }

  async function createAddress(data: Partial<Address>) {
    if (!data.suffix?.trim()) {
      data.suffix = null
    }

    await axiosClient.request<Address>({
      url: '/addresses',
      method: 'POST',
      data: data,
    })
  }

  async function fetchAddresses() {
    const response = await axiosClient.request<Address[]>({
      url: '/addresses',
      method: 'GET',
    })

    addresses.value = response.data
  }

  return {
    address,
    addresses,
    fetchCustomerAddress,
    updateCustomerAddress,
    createAddress,
    fetchAddresses,
  }
})
